import { motion } from "framer-motion";

export default function Projects() {
  const projects = [
    {
      title: "Cloud Resume Challenge",
      description:
        "A full-stack resume site on AWS using S3 + CloudFront (HTTPS, custom domain), Lambda + API Gateway, DynamoDB for a visitor counter, Route 53, and CI/CD with GitHub Actions and Terraform.",
      link: "https://your-resume-site.com",
    },
    {
      title: "Kubernetes Homelab",
      description:
        "Production-style on-prem K8s cluster with HA control plane, containerd, Calico CNI, TLS, persistent storage, and monitoring/alerting (Prometheus + Grafana).",
      link: "https://github.com/yourgithub/k8s-homelab",
    },
    {
      title: "Infra as Code Starter Kit",
      description:
        "Reusable Terraform modules for VPC/VNet, subnets, security groups/NSGs, and IAM with environment-based variables and GitHub Actions pipelines.",
      link: "https://github.com/yourgithub/iac-starter",
    },
    {
      title: "Server Hardening Playbooks",
      description:
        "Ansible roles/playbooks for Windows and Linux baseline hardening, patching, logging, and backup jobs with inventory grouping and tags.",
      link: "https://github.com/yourgithub/ansible-hardening",
    },
  ];

  return (
    <motion.section
      id="projects"
      className="min-h-screen px-6 py-20 bg-white dark:bg-gray-900 text-gray-800 dark:text-white"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
    >
      <div className="max-w-5xl w-full">
        <h2 className="text-5xl font-bold mb-10 border-b-4 border-blue-500 w-fit">
          Projects
        </h2>

        <div className="space-y-10">
          {projects.map((project, index) => (
            <div
              key={index}
              className="border-l-4 border-blue-500 pl-6 hover:shadow-md transition-shadow duration-200"
            >
              <h3 className="text-2xl font-semibold text-blue-700 dark:text-blue-300 mb-1">
                {project.title}
              </h3>
              <p className="text-lg text-gray-700 dark:text-gray-200 mb-2">
                {project.description}
              </p>
              <a
                href={project.link}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 dark:text-blue-400 hover:underline text-base"
              >
                View Project →
              </a>
            </div>
          ))}
        </div>
      </div>
    </motion.section>
  );
}
